module.exports = __webpack_public_path__ + "static/media/Lateral_Normal_Z1.f613f2df.png";